import { CommonModule, isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DialogModule, Dialog } from 'primeng/dialog';
import { GlobalProperties } from '@shared/models/classes/GlobalProperties';
import { UiService } from '@shared/services/ui.service';
import { PmButtonComponent } from '@shared/components/pm-button/pm-button.component';
import { PmIconComponent } from '@shared/components/pm-icon/pm-icon.component';
import { PmEmojiComponent } from '@shared/components/pm-emoji/pm-emoji.component';

@Component({
  standalone: true,
  selector: 'pm-dialog',
  imports: [
    CommonModule,
    DialogModule,
    PmButtonComponent,
    PmIconComponent,
    PmEmojiComponent,
  ],
  templateUrl: './pm-dialog.component.html',
  styleUrl: './pm-dialog.component.scss',
})
export class PmDialogComponent
  extends GlobalProperties
  implements AfterViewInit, OnChanges
{
  @HostListener('document:keyup.enter', ['$event' as any])
  enterEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.save();
    }
  }
  @Input() header: string | undefined = '';
  @Input() headerIcon: string | undefined = '';
  @Input() visible = false;
  @Input() saveDisabled = false;
  @Input() closable = true;
  @Input() cancelButtonLabel: string = $localize`Anuluj`;
  @Input() confirmButtonLabel: string = $localize`Zastosuj`;
  @Input() autoWidth = false;
  @Input() hideCancelButton = false;
  @Input() hideSaveButton = false;
  @Input() confirmButtonFullWidth = false;
  @Input() hideActionsBorder = false;
  @Input() hideHeaderBorder = false;
  @Input() styleClass: string | undefined = undefined;
  @Input() hideActions = false;
  @Input() emoji = '';
  @Input() emojiSize = 32;
  @Input() customActionsTemplate?: TemplateRef<any>;

  @Output() closeEvent = new EventEmitter();
  @Output() saveEvent = new EventEmitter();
  debounceHandle: any = null;
  isVisible = false;
  isServer: boolean;

  @ViewChild('pDialogComponent') pDialogComponent!: Dialog;

  constructor(
    @Inject(UiService) protected uIService: UiService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    super();
    this.isServer = isPlatformServer(this.platformId);
  }

  ngAfterViewInit() {
    this.isVisible = this.visible;
  }

  ngOnChanges() {
    if (this.visible !== this.isVisible) {
      this.isVisible = this.visible;
    }
  }

  close() {
    this.isVisible = false;
    this.debounce(() => {
      this.closeEvent.emit();
    });
  }

  save() {
    if (this.saveDisabled) return;
    this.saveEvent.emit();
  }

  debounce(func: (...args: any[]) => void, delay = 250) {
    if (this.debounceHandle !== null) clearTimeout(this.debounceHandle);
    this.debounceHandle = setTimeout(func, delay);
  }
}
